<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '所有请假', path: '/leave/all' }"
      :button-array="buttonArray"
      @exportExcel="exportExcel"
    ></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="10" style="margin-left: 10px">
          <el-col :span="4">
            <el-input
              placeholder="请输入请假人员"
              type="text"
              v-model="qparam.userName"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="qparam.leaveType" placeholder="请选择请假类型" @change="selectLevelType">
              <el-option
                  v-for="item in leaveTypeData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" v-show="solution">
            <el-date-picker
              v-model="qparam.month"
              type="month"
              value-format="yyyy-MM"
              placeholder="按月份查询"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="8" v-show="!solution">
            <el-date-picker
              v-model="qparam.createTimeArr"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="5" style="float: right">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >
            <el-button icon="el-icon-search" type="primary" @click="search"
              >查询</el-button
            >
          </el-col>
          <el-col :span="3" style="float: right; margin-top: 6px">
            <el-switch v-model="solution" active-text="按月查询"> </el-switch>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="申请人" prop="userName" width="180"/>
          <el-table-column label="请假类型" prop="leaveType" width="180">
            <template slot-scope="scope">
              <el-tag type="success">
                {{ getLeaveTypeLabel(scope.row.leaveType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="请假事由" prop="leaveSubject" />
          <el-table-column label="请假开始时间" prop="leaveBegainTime" width="200"/>
          <el-table-column label="请假结束时间" prop="leaveEndTime" width="200"/>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { requestLeaveList, requestExportLeave } from "../../../api";
import Title from "../../Title";
export default {
  name: "allout",
  components: { Title },
  data() {
    return {
      solution: false,
      tableData: [],
      totalElements: 0,
      qparam: {
        current: 1,
        size: 10,
        userName: "",
        leaveType: "",
        month: "",
        createTimeArr: [],
      },
      apply: {},
      buttonArray: [
        {
          type: "primary",
          title: "导出",
          method: "exportExcel",
          disabled: false,
        },
      ],
      leaveTypeData: [
        { value: 1, label: '事假' },
        { value: 2, label: '婚假' },
        { value: 3, label: '丧假' },
        { value: 4, label: '病假' },
        { value: 5, label: '年假' },
        { value: 6, label: '产假' },
        { value: 7, label: '其他' }
      ]
    };
  },
  methods: {
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData();
    },
    resetQparam() {
      this.qparam.userName = "";
      this.qparam.month = "";
      this.qparam.createTimeArr = [];
      this.qparam.startTime = "";
      this.qparam.endTime = "";
      this.initTableData();
      window.location.href = "";
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData();
    },
    async search() {
      this.qparam.current = 1;
      await this.initTableData();
    },
    async initTableData() {
      if (this.solution) {
        this.qparam.createTimeArr = [];
      } else {
        this.qparam.month = "";
      }
      if (this.qparam.createTimeArr && this.qparam.createTimeArr.length > 0) {
        this.qparam.startTime = this.qparam.createTimeArr[0];
        this.qparam.endTime = this.qparam.createTimeArr[1];
      }
      const createTimeArr = this.qparam.createTimeArr;
      this.qparam.createTimeArr = "";
      console.log('请求参数:',this.qparam)
      const res = await requestLeaveList(this.qparam);
      if (res.code === 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
      this.qparam.createTimeArr = createTimeArr;
    },
    async exportExcel() {
      let param = {};
      if (this.solution) {
        this.qparam.createTimeArr = [];
      } else {
        this.qparam.month = "";
      }
      if (this.qparam.createTimeArr && this.qparam.createTimeArr.length > 0) {
        param.startTime = this.qparam.createTimeArr[0];
        param.endTime = this.qparam.createTimeArr[1];
      }
      param.month = this.qparam.month;
      param.userName = this.qparam.userName;
      const res = await requestExportLeave(param);
      if (res.code === 200) {
        window.location.href = res.object;
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    getLeaveTypeLabel(value) {
      const item = this.leaveTypeData.find(item => item.value === value);
      return item ? item.label : '';
    },
    selectLevelType(value) {
      this.qparam.leaveType = value;
      this.initTableData();
    },
  },
  created() {
    this.initTableData();
  },
};
</script>

<style scoped></style>
